import { Fragment, useMemo } from 'react';
import { useQuery } from 'react-query';

import { IResponse, INews } from '../../models';
import { getNews } from '../../fetch';
import { groupBy } from '../../helpers';
import { Typography, Box } from '@mui/material';
import { Loader, Page, PageTitle } from '../../components';
import { NewsCard } from './news-card';

export const NewsPage = () => {
  const { isLoading, data: newsData } = useQuery<IResponse<INews[]>, Error>([getNews], () =>
    getNews({
      onlyActive: true,
      sortBy: 'CreatedDate',
      sortDirection: 'Desc'
    })
  );
  const news: {
    [category: string]: INews[];
  } = useMemo(() => (newsData?.records ? groupBy(newsData.records, 'category') : []), [newsData]);

  return (
    <Page title="News">
      <PageTitle title="News" />
      {isLoading && <Loader position="centered" />}
      {!isLoading &&
        news &&
        Object.keys?.(news)?.map((category, index) => {
          return (
            <Fragment key={`${index}`}>
              <Box padding="1rem" border="1px solid #e1e1e1" borderRadius="4px" flex={1} mb={1}>
                <Typography
                  color="secondary"
                  variant="h6"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: 'bold'
                  }}
                  gutterBottom
                >
                  {category}
                </Typography>
                {news[category].map((newsItem, newsIndex) => {
                  return (
                    <Box mb={1} key={`${newsIndex}`}>
                      <NewsCard isNewsPage newsItem={newsItem} showIcon={false} />
                    </Box>
                  );
                })}
              </Box>
            </Fragment>
          );
        })}
    </Page>
  );
};
